export const BEST_PRICE_URL: string =
  'https://s3.amazonaws.com/static.secretescapes.com/assets/images/icons/usp/usp-best-prices.png';
export const ENDS_SOON_URL: string =
  'https://s3.amazonaws.com/static.secretescapes.com/assets/images/icons/usp/usp-ends-soon.png';
export const HAND_PICKED_URL: string =
  'https://s3.amazonaws.com/static.secretescapes.com/assets/images/icons/usp/usp-handpicked.png';
